<div class="fixed bottom-6 right-6 z-9999 flex flex-col gap-2 pointer-events-none">
  @for (toast of toastService.toasts(); track toast.id) {
    <div
      [ngClass]="toast.type === 'success' ? 'bg-green-600 text-white' : 'bg-red-500 text-white'"
      class="flex items-center gap-3 px-4 py-3 rounded-xl shadow-lg text-sm font-medium pointer-events-auto min-w-64 max-w-sm animate-in"
    >
      @if (toast.type === 'success') {
        <img src="/icons/check-icon.svg" class="w-4 h-4 shrink-0" alt="" />
      } @else {
        <img src="/icons/close-icon.svg" class="w-4 h-4 shrink-0" alt="" />
      }
      <span class="flex-1">{{ toast.message }}</span>
      <button
        type="button"
        (click)="toastService.dismiss(toast.id)"
        class="shrink-0 opacity-70 hover:opacity-100 transition-opacity cursor-pointer"
      >
        <img src="/icons/close-icon.svg" class="w-3.5 h-3.5" alt="Dismiss" />
      </button>
    </div>
  }
</div>
